export default __webpack_public_path__ + "static/media/landing-image-plantations.94a6e53d.jpg";